const convocatorias = [
  
  {
    titulo: 'Apoyo Para el Bienestar de las Personas Migrantes 2026',
    url: '/Convocatorias/Migrantes2026'
  },
  
  {
    titulo: 'Invierte en Ti, Invierte en Hidalgo 2026 Segunda Edición',
    url: '/Convocatorias/InvierteH2'
  },
  
  {
    titulo: 'Apoyo económico a personas artesanas, para acceder a capacitación técnica con la finalidad de fortalecer el mejoramiento de la condición productiva artesanal 2026',
    url: '/Convocatorias/Capacitacionartesanos2026'
  },
  {
    titulo: '18.ª EDICIÓN DEL CONCURSO REGIONAL DE BORDADOS Y TEXTILES DE LA REGIÓN OTOMÍ-TEPEHUA 2026',
    url: '/Convocatorias/Bordadosot2026'
  },
  {
    titulo: '13.ª EDICIÓN DEL CONCURSO REGIONAL DE ARTESANÍAS DE LA HUASTECA HIDALGUENSE 2026',
    url: '/Convocatorias/Artesaniashh2026'
  },
  {
    titulo: '9.ª EDICIÓN DEL CONCURSO REGIONAL DE ARTESANÍAS DEL VALLE DEL MEZQUITAL 2026',
    url: '/Convocatorias/Artesaniasvm2026'
  },
  {
    titulo: 'Programa "Bienestar para Personas Artesanas" Ejercicio Fiscal 2026',
    url: '/PBPA'
  },
  {
    titulo: 'Programa "Bienestar de Madres Trabajadoras" Ejercicio Fiscal 2026',
    url: '/Convocatorias/BMT'
  },
  {
    titulo: 'Programa "Apoyo para el Bienestar y Desarrollo" Ejercicio Fiscal 2026',
    url: '/Convocatorias/BYD'
  },
  {
    titulo: 'Programa "Bienestar de Personas Cuidadoras de Personas con Discapacidad" Ejercicio Fiscal 2026',
    url: '/BPCD'
  },
  {
    titulo: 'Programa "Desarrollo Inclusivo" Para el Ejercicio Fiscal 2026',
    url: '/Programas/DI2026'
  },
  {
    titulo: 'Programa "Atención a Personas Migrantes" Para el Ejercicio Fiscal 2026',
    url: '/Convocatorias/Conv001'
  },
  {
    titulo: '13ª. EDICIÓN DEL CONCURSO ESTATAL DE ARTESANÍAS “HECHO EN HIDALGO 2026"',
    url: 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_HECHO_EN_HIDALGO.pdf',
    anexos: [
      {
        nombre: 'Anexo 2',
        url: 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/XIII_CEA/ANEXO_2.pdf'
      }
    ]
  },
  {
    titulo: 'APOYOS ECONÓMICOS PARA RECONOCER LA TRAYECTORIA DE PERSONAS ARTESANAS 2026',
    url: '/documento/31',
    anexos: [
      { nombre: 'Anexo 2', url: 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/AE_TPA/ANEXO_2.pdf' },
      { nombre: 'Anexo 3', url: 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/AE_TPA/ANEXO_3.pdf' },
      { nombre: 'Anexo 6', url: 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/AE_TPA/ANEXO_6.pdf' }
    ]
  },
  {
    titulo: 'Convocatoria Xantolo 2025',
    url: '/documento/32',
    anexos: [
      { nombre: 'Formatos', url: '/assets/pdfs/ANEXOS.pdf' }
    ]
  }
];

export default convocatorias;